import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '@material-ui/core';
import { getHelpCategoriesApi } from 'api/help';
import { BackdropCircular } from 'components';
import MainTabsList from './MainTabsList';
import MainTabsForm from './MainTabsForm';


const MainTabs = () => {
  const dispatch = useDispatch();
  const [category, setCategory] = useState();
  const { isLoadingHelpCategories } = useSelector((state) => state.help);

  useEffect(() => {
    getHelpCategoriesApi({ dispatch });
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25 my-4 ml-10 pr-10">
      {category ?
        <MainTabsForm category={category} setCategory={setCategory} />
        :
        <>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setCategory({})}
            className="mb-8 ml-4"
          >
            <Icon className="mr-2">add</Icon>
            <span>Add New Category</span>
          </Button>
          <MainTabsList setCategory={setCategory} />
        </>
      }
      <BackdropCircular loading={isLoadingHelpCategories} />
    </div>
  );
};

export default MainTabs;
